import { BasicSettings } from "../../views/BasicSettings";

export function Basic() {
    return (
        <>
            <BasicSettings />
        </>
    );
}
